<template>
  <div>
    <el-row :gutter="15" type="flex" justify="center">
      <el-col :xs="{span: 24}" :sm="{span: 8}">
        <el-card>
          <div slot="header" class="clearfix">
            <b>Upgrade to add business contacts</b>
          </div>
          <p>Upgrade to a Droplii mentor subsciption to manage your contacts.</p>
          <el-button type="primary" @click="navToUpgrade">Upgrade now!</el-button>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  methods: {
    navToUpgrade() {
      window.location.href = 'https://droplii.com/upgrade-pricing/'
    }
  }
}
</script>

<style>
</style>
